
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"34","height":"34","rx":"3","fill":"#000"}}),_c('path',{attrs:{"d":"M21.237 9.823h-8.45v14.329h8.45V9.822z","fill":"#FF5F00"}}),_c('path',{attrs:{"d":"M13.64 17.013c0-2.785 1.241-5.443 3.36-7.165-3.8-3.114-9.327-2.43-12.323 1.52-2.995 3.948-2.338 9.695 1.486 12.784 3.19 2.607 7.647 2.607 10.837.025a9.291 9.291 0 01-3.36-7.164z","fill":"#EB001B"}}),_c('path',{attrs:{"d":"M30.346 22.658v-.304h.121v-.05h-.292v.05h.122v.304h.049zm.56 0v-.354h-.098l-.097.253-.098-.253h-.097v.354h.073v-.278l.098.228h.072l.098-.228v.278h.049zm.268-5.645c0 5.038-3.921 9.114-8.768 9.114A8.47 8.47 0 0117 24.177c3.8-3.114 4.457-8.86 1.485-12.81A8.752 8.752 0 0017 9.823c3.8-3.114 9.327-2.43 12.323 1.544 1.193 1.595 1.85 3.595 1.85 5.646z","fill":"#F79E1B"}})])
          )
        }
      }
    